export default {
  translations: { // namespace
    home: {
      messageTitle: 'Multiply es una herramienta para crear anuncios de video con las marcas con las que trabajas. ' +
      '¡Descarga la aplicación para probarlo!'
    }
  }
};
